const GetMaster = (token, nameMaster, cb) => {
  fetch(`${process.env.REACT_APP_API}/admin/api/master/${nameMaster}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((json) => cb(null, json))
    .catch((err) => cb(err, null));
};

export default GetMaster;
